module.exports = __webpack_public_path__ + "static/media/vaccine.92ff7af2.svg";